<template>
  <v-dialog max-width="540" :value="visible" content-class="rounded-10" style="z-index: 15" @input="$emit('input', $event)">
    <v-sheet class="rounded-10 px-4 px-md-4 py-4 py-md-10 d-flex flex-column align-center" color="#fffbf2" style="border: 2px solid #bebebe">
      <img src="@/assets/warning.png" class="icon" />

      <!-- 첫번째 페이지 -->
      <div v-if="currentPage === 1" style="width: 100%">
        <div class="caution-title text-h6 text-md-h5 text-center black--text text--darken-2 font-weight-bold my-1 my-md-2" style="word-break: keep-all; white-space: normal">{{ $t("dialog.refund-title") }}</div>
        <!-- text-wrap은 줄바꿈·빈칸을 그대로 보여 주므로 한 줄로 붙여 쓴다 -->
        <p class="caution-intro text-center px-1 mb-3 text-body-2 text-md-body-1 text-wrap">{{ $t("dialog.policy.intro") }}<template v-if="!readonly"><br />{{ $t("dialog.refund-warning-check") }}</template></p>

        <ReservationPolicySummary :show-visit-rule="productType === 'premium'" />

        <v-checkbox v-if="!readonly" v-model="isCheck1" class="caution-agree" color="primary" hide-details :label="$t('dialog.refund-agree-check-label')" />
      </div>

      <!-- 두번째 페이지 -->
      <div v-else-if="currentPage === 2" class="px-0" style="width: 100%">
        <!-- 두번째 페이지 내용 -->
        <div class="text-h6 text-md-h5 text-center black--text text--darken-2 font-weight-bold my-1 my-md-2">{{ $t("dialog.noshow-warning-title") }}</div>
        <div class="text-center px-4 text-body-2 text-md-body-1 text-wrap" v-html="$t('dialog.noshow-warning-message-1', { shootingTime: SHOOTING_TIME })"></div>
        <div class="text-center px-4 text-body-2 text-md-body-1 text-wrap" v-html="$t('dialog.noshow-warning-message-2')"></div>

        <v-img :src="getNoshowGuideImage()" width="90%" max-width="400" class="my-2 mx-auto" aspect-ratio="2.8" contain></v-img>

        <v-container class="d-flex flex-start py-0" fluid>
          <ul class="text-body-2 text-md-body-1 grey--text text--darken-2">
            <li>{{ $t("dialog.noshow-warning-list-1") }}</li>
          </ul>
        </v-container>

        <v-checkbox v-if="!readonly" v-model="isCheck2" class="caution-agree" color="primary" hide-details :label="$t('dialog.noshow-agree-check-label')" />
      </div>

      <!-- 세번째 페이지 -->
      <div v-else-if="currentPage === 3" class="px-0" style="width: 100%">
        <!-- 세번째 페이지 내용 -->
        <div class="text-h6 text-md-h5 text-center black--text text--darken-2 font-weight-bold my-1 my-md-2 text-wrap">{{ $t("dialog.composite-warning-title") }}</div>
        <div class="text-center px-4 text-body-2 text-md-body-1 text-wrap" v-html="$t('dialog.composite-warning-message-1')"></div>
        <v-img src="@/assets/reservation/composite_bg.png" width="90%" max-width="400" class="my-1 mx-auto" aspect-ratio="1.9" contain></v-img>

        <v-container class="d-flex flex-start py-0" fluid>
          <ul class="text-body-2 text-md-body-1 grey--text text--darken-2">
            <li>{{ $t("dialog.composite-warning-list-1") }}</li>
            <li>{{ $t("dialog.composite-warning-list-2") }}</li>
          </ul>
        </v-container>

        <v-checkbox v-if="!readonly" v-model="isCheck3" class="caution-agree" color="primary" hide-details :label="$t('dialog.quality-agree-check-label')" />
      </div>

      <!-- 쪽이 여러 개일 때만 지금 몇 쪽인지 보여 준다. 누를 수 없는 화살표 모양은 두지 않는다. -->
      <p v-if="totalPages > 1" class="caution-page grey--text text--darken-2 text-body-2 mt-3 mb-0">{{ currentPage }} / {{ totalPages }}</p>

      <div class="caution-actions">
        <v-btn color="white" class="dialog_btn caution-actions__back rounded-2 grey--text" depressed @click="prevPage" large>
          {{ currentPage === 1 ? $t("button.back") : $t("button.prev") }}
        </v-btn>

        <v-btn
          color="#D8207E"
          class="dialog_btn caution-actions__next rounded-2"
          depressed
          @click="nextPage"
          large
          :disabled="(currentPage === 1 && !isCheck1) || (currentPage === 2 && !isCheck2) || (currentPage === 3 && !isCheck3)"
        >
          {{ nextLabel }}
        </v-btn>
      </div>
    </v-sheet>
  </v-dialog>
</template>

<script>
import { SHOOTING_TIME } from "@/constant"
import { mapState } from "vuex"
import ReservationPolicySummary from "@/views/components/ReservationPolicySummary"

export default {
  components: {
    ReservationPolicySummary,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: String,
      default: "makershot",
    },
  },
  data: () => ({
    isCheck1: false,
    isCheck2: false,
    isCheck3: false,
    currentPage: 1,
  }),
  computed: {
    ...mapState(["lang"]),
    SHOOTING_TIME() {
      return SHOOTING_TIME
    },
    totalPages() {
      return this.productType === "premium" ? 1 : 3
    },
    // 마지막 쪽 단추는 누르면 일어나는 일을 그대로 말한다(결제 직전이면 '동의하고 결제하기').
    nextLabel() {
      if (this.currentPage !== this.totalPages) return this.$t("button.next")
      return this.readonly ? this.$t("button.ok") : this.$t("button.agree-and-pay")
    },
  },
  created() {
    if (this.readonly) {
      this.isCheck1 = true
      this.isCheck2 = true
      this.isCheck3 = true
    }
  },
  methods: {
    nextPage() {
      if (this.currentPage === this.totalPages) {
        this.$emit("agree")
      } else {
        this.currentPage++
      }
    },
    prevPage() {
      if (this.currentPage === 1) {
        this.$emit("cancel")
      } else {
        this.currentPage--
      }
    },
    getNoshowGuideImage() {
      let fileName = "noshow-guide.png"
      switch (this.lang) {
        case "jp":
          fileName = "noshow-guide-jp.png"
          break
        case "en":
          fileName = "noshow-guide-en.png"
          break
        default:
          fileName = "noshow-guide.png"
          break
      }

      return require(`@/assets/reservation/${fileName}`)
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        // 다시 열면 첫 쪽부터, 동의 칸은 비운 채로 시작한다(다시보기는 처음부터 채워 둔다).
        this.currentPage = 1
        this.isCheck1 = this.readonly
        this.isCheck2 = this.readonly
        this.isCheck3 = this.readonly
      }
    },
  },
}
</script>

<style scoped>
.icon {
  width: 30px;
  height: 30px;
}

@media (min-width: 600px) {
  .icon {
    width: 60px;
    height: 60px;
  }
}

.dialog_btn {
  border: 2px solid #dadada !important;
  font-size: 16px;
}
::v-deep .v-btn:not(.v-btn--disabled) {
  color: white;
}

/* 동의 칸: 글자를 눌러도 체크된다. 누르는 자리는 44px로 둔다. */
/* 전역 규칙(.v-input--selection-controls { margin-top: 0 !important })을 이겨야 위 카드와 떨어진다. */
.caution-agree {
  justify-content: center;
  margin-top: 16px !important;
  padding-top: 0;
}

.caution-agree ::v-deep .v-label {
  display: flex;
  align-items: center;
  min-height: 44px;
  color: #433b3f;
  font-size: 14px;
  line-height: 1.4;
  word-break: keep-all;
}

/* 일본어는 keep-all이면 줄이 바뀌지 않아 창 밖으로 넘친다. 되는 브라우저에서는 말 마디에서 줄을 바꾼다. */
.caution-agree:lang(ja) ::v-deep .v-label,
.text-wrap:lang(ja) {
  word-break: normal;
  line-break: strict;
}

@supports (word-break: auto-phrase) {
  .caution-agree:lang(ja) ::v-deep .v-label,
  .text-wrap:lang(ja) {
    word-break: auto-phrase;
  }
}

.caution-page {
  text-align: center;
}

/* 아래 단추 두 개: '돌아가기'는 좁게, 다음·동의 단추는 남은 너비를 다 쓴다. */
.caution-actions {
  display: grid;
  grid-template-columns: minmax(96px, 0.5fr) minmax(0, 1fr);
  gap: 10px;
  width: 100%;
  margin-top: 14px;
}

/* 단추 글자는 적어 둔 그대로 보인다. 전역 규칙(.v-btn { text-transform: capitalize !important })이
   영어 'Agree and Pay'의 and까지 대문자로 바꾸지 않게 한다. */
.caution-actions .v-btn {
  min-width: 0 !important;
  font-size: 17px !important;
  letter-spacing: -0.01em;
  text-transform: none !important;
}

/* 제목과 첫 안내 두 줄: 끝에 한두 낱말만 남지 않게 줄 길이를 고르게 한다. */
.caution-title,
.caution-intro {
  text-wrap: balance;
}

.text-wrap {
  white-space: pre-wrap; /* CSS3 */
  word-wrap: break-word; /* IE */
  word-break: keep-all; /* 긴 단어 처리 */
  max-width: 100%; /* 컨테이너 최대 너비 설정 */
}
</style>
